module.exports = __webpack_public_path__ + "img/icon_exchange_money.695937c7.png";